import { provideHeadlessUseId, useId } from '#imports'

export const useProvideHeadlessUiId = () => {
  // it's fine here, it is right from docs
  // eslint-disable-next-line vue-composable/composable-placement
  provideHeadlessUseId(() => useId())
}
